export default __webpack_public_path__ + "static/media/21.25719b90.jpg";